import { NewCheckoutComponent } from './newCheckout/newCheckout.component';
import { CheckoutComponent } from './checkout.component';

export const ComponentRouter = angular
    .module('checkout.componentRouter', [
        NewCheckoutComponent,
        CheckoutComponent
    ])
    .component('componentRouter', {
        template: `
            <checkout
                ng-if="!$ctrl.useNewCarts"
                cart="$ctrl.cart"
                bag="$ctrl.bag"
                store-info="$ctrl.storeInfo"
                return-url="$ctrl.returnUrl"
                available-payment-methods="$ctrl.availablePaymentMethods"
                is-logged-in="$ctrl.isLoggedIn"
                shipping-methods="$ctrl.shippingMethods"
                stripe-publishable-key="$ctrl.stripePublishableKey"
                use-address-verification="$ctrl.useAddressVerification"
            ></checkout>
            <new-checkout
                ng-if="$ctrl.useNewCarts"
                cart="$ctrl.cart"
                bag="$ctrl.bag"
                store-info="$ctrl.storeInfo"
                return-url="$ctrl.returnUrl"
                available-payment-methods="$ctrl.availablePaymentMethods"
                is-logged-in="$ctrl.isLoggedIn"
                shipping-methods="$ctrl.shippingMethods"
                stripe-publishable-key="$ctrl.stripePublishableKey"
                use-address-verification="$ctrl.useAddressVerification"
                tenant-id="$ctrl.tenantId"
            ></new-checkout>
        `,
        bindings: {
            cart: '<',
            useNewCarts: '<',
            bag: '<',
            storeInfo: '<',
            returnUrl: '<',
            availablePaymentMethods: '<',
            isLoggedIn: '<',
            shippingMethods: '<',
            stripePublishableKey: '<',
            useAddressVerification: '<',
            tenantId: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/componentRouter.component.js